export const convertSnakeCaseToReadableText = (value: string): string =>
  value.split('_').join(' ')
